import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Controller, useFieldArray } from "react-hook-form";
import { Grid, MenuItem, Typography } from "@mui/material";

import NumberFormatTheme from "../../../../shared/general/NumberFormatTheme";
import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import ButtonBlue from "../../../../shared/general/ButtonBlue";

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

const LeaveStepForm = (props) => {

  const { useHookForm, indexLeaveType } = props;

  const { t } = useTranslation();

  const useFieldArrayLeaveStepList = useFieldArray({
    control: useHookForm.control,
    name: `leaveTypeList.${indexLeaveType}.leaveStepList`,
  });

  const handleInsertLeaveStep = () => {
    useFieldArrayLeaveStepList.append({
      conditionType: "SERV",
      leaveValue: "",
      carryValue: "",
      lessThanYear: "",
      moreThanYears: "",
    })
  }

  return (
    <Fragment>
      {useFieldArrayLeaveStepList.fields.map((field, index) => (
        <Grid key={field.id} item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontSize="18px" fontWeight="500">{t("Condition")} {index+1}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography fontSize="14px" fontWeight="500" paddingBottom="4px">{t("ConditionType")}</Typography>
              <Controller
                name={`leaveTypeList.${indexLeaveType}.leaveStepList.${index}.conditionType`}
                control={useHookForm.control}
                render={({ field, fieldState }) => (
                  <TextFieldTheme
                    {...field}
                    select
                    disabled
                    helperText={fieldState.error? fieldState.error.message: null}
                    error={fieldState.error? true: false}
                  >
                    <MenuItem value="SERV">{t("YearOfService")}</MenuItem>
                  </TextFieldTheme>
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontSize="14px" fontWeight="500" paddingBottom="4px">{t("SinceServiceOfYear")}</Typography>
              <Controller
                name={`leaveTypeList.${indexLeaveType}.leaveStepList.${index}.lessThanYear`}
                control={useHookForm.control}
                render={({ field, fieldState }) => (
                  <TextFieldTheme
                    {...field}
                    select
                    helperText={fieldState.error? fieldState.error.message: null}
                    error={fieldState.error? true: false}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8">8</MenuItem>
                    <MenuItem value="9">9</MenuItem>
                    <MenuItem value="10">10</MenuItem>
                    <MenuItem value="11">11</MenuItem>
                    <MenuItem value="12">12</MenuItem>
                    <MenuItem value="13">13</MenuItem>
                    <MenuItem value="14">14</MenuItem>
                    <MenuItem value="15">15</MenuItem>
                    <MenuItem value="16">16</MenuItem>
                    <MenuItem value="17">17</MenuItem>
                    <MenuItem value="18">18</MenuItem>
                    <MenuItem value="19">19</MenuItem>
                    <MenuItem value="20">20</MenuItem>
                    <MenuItem value="21">21</MenuItem>
                    <MenuItem value="22">22</MenuItem>
                    <MenuItem value="23">23</MenuItem>
                    <MenuItem value="24">24</MenuItem>
                    <MenuItem value="25">25</MenuItem>
                  </TextFieldTheme>
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontSize="14px" fontWeight="500" paddingBottom="4px">{t("UntilServiceOfYear")}</Typography>
              <Controller
                name={`leaveTypeList.${indexLeaveType}.leaveStepList.${index}.moreThanYears`}
                control={useHookForm.control}
                render={({ field, fieldState }) => (
                  <TextFieldTheme
                    {...field}
                    select
                    helperText={fieldState.error? fieldState.error.message: null}
                    error={fieldState.error? true: false}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7</MenuItem>
                    <MenuItem value="8">8</MenuItem>
                    <MenuItem value="9">9</MenuItem>
                    <MenuItem value="10">10</MenuItem>
                    <MenuItem value="11">11</MenuItem>
                    <MenuItem value="12">12</MenuItem>
                    <MenuItem value="13">13</MenuItem>
                    <MenuItem value="14">14</MenuItem>
                    <MenuItem value="15">15</MenuItem>
                    <MenuItem value="16">16</MenuItem>
                    <MenuItem value="17">17</MenuItem>
                    <MenuItem value="18">18</MenuItem>
                    <MenuItem value="19">19</MenuItem>
                    <MenuItem value="20">20</MenuItem>
                    <MenuItem value="21">21</MenuItem>
                    <MenuItem value="22">22</MenuItem>
                    <MenuItem value="23">23</MenuItem>
                    <MenuItem value="24">24</MenuItem>
                    <MenuItem value="25">25</MenuItem>
                    <MenuItem value="99">ขึ้นไป</MenuItem>
                  </TextFieldTheme>
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontSize="14px" fontWeight="500" paddingBottom="4px">{t("TotalLeaveDays")}</Typography>
              <Controller
                name={`leaveTypeList.${indexLeaveType}.leaveStepList.${index}.leaveValue`}
                control={useHookForm.control}
                render={({ field, fieldState }) => (
                  <TextFieldTheme
                    {...field}
                    inputProps={{
                      placeholder: t("Leave.Unlimited"),
                      allowNegative: false,
                      value: field.value,
                      onValueChange: (values) => {
                        const { value } = values;
                        field.onChange(value)
                      },
                      decimalScale: 0,
                      thousandSeparator: ",",
                      suffix: ` ${t("Days")}`
                    }}
                    onChange={()=>{}}
                    InputProps={{
                      inputComponent: NumberFormatTheme,
                    }}
                    helperText={fieldState.error? fieldState.error.message: null}
                    error={fieldState.error? true: false}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography fontSize="14px" fontWeight="500" paddingBottom="4px">{t("CannotCarryOverLeaveNextRound")}</Typography>
              <Controller
                name={`leaveTypeList.${indexLeaveType}.leaveStepList.${index}.carryValue`}
                control={useHookForm.control}
                render={({ field, fieldState }) => (
                  <TextFieldTheme
                    {...field}
                    inputProps={{
                      placeholder: t("Leave.Unlimited"),
                      allowNegative: false,
                      value: field.value,
                      onValueChange: (values) => {
                        const { value } = values;
                        field.onChange(value)
                      },
                      decimalScale: 0,
                      thousandSeparator: ",",
                      suffix: ` ${t("Days")}`
                    }}
                    onChange={()=>{}}
                    InputProps={{
                      inputComponent: NumberFormatTheme,
                    }}
                    helperText={fieldState.error? fieldState.error.message: null}
                    error={fieldState.error? true: false}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12}>
        <ButtonBlue
          variant="outlined"
          onClick={handleInsertLeaveStep}
          startIcon={<AddCircleOutlineRoundedIcon />}
        >
          {t("AddCondition")}
        </ButtonBlue>
      </Grid>
    </Fragment>
  )
}

export default LeaveStepForm;